/* eslint-disable import/no-unresolved */
import { useReactiveVar } from '@apollo/client';
import {
    Select, SelectOption, Button, Radio, RadioGroup,
} from 'appkit-react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { isFileUploadingVar } from 'Apollo/config';
import closeReport from '../../../../assets/images/close-report.svg';

const FFIEC041UploadTabThree = ({
    fileName, onHandleUpload, selectedQtr, setSelectedQtr,
    handleFileUpload, onHandleReportClose, ques1, ques3,
    ques8, ques9, disableUploadButton, institution, onSelectInstitution,
}) => (
    <>
        <div className="true-comply-upload__steptwo-head">
            <div className="true-comply-upload__steptwo-head-left">
                <div className="true-comply-upload__steptwo-head-left-title">Select your files</div>
                <div className="true-comply-upload__steptwo-head-left-subtext">Please select the corresponding report .csv files.</div>
            </div>
            <div className="true-comply-upload__steptwo-head-right">
                <Button
                    className="true-comply-upload__steptwo-head-right-btn"
                    onClick={() => onHandleUpload()}
                    aria-hidden="true"
                    disabled={disableUploadButton}
                    data-testid="handle-upload-btn"
                    isLoading={useReactiveVar(isFileUploadingVar)}
                >
                    Upload files
                </Button>
            </div>
            <div className="hr-line" />
        </div>
        <div className="true-comply-upload__stepthree-body">
            <div className="true-comply-upload__stepthree-body__period_wrapper">
                <div className="true-comply-upload__stepthree-body__period_wrapper-left">Select Period</div>
                <div className="true-comply-upload__stepthree-body__period_wrapper-right">
                    <DatePicker
                        selected={selectedQtr}
                        onChange={date => setSelectedQtr(date)}
                        dateFormat="yyyy, QQQ"
                        showQuarterYearPicker
                        className="true-comply-upload__stepthree-body__period_wrapper-right-date-picker"
                    />
                </div>
            </div>
            <div className="true-comply-upload__stepthree-body__period_wrapper">
                {
                    !fileName ? (
                        <>
                            <div className="true-comply-upload__stepthree-body__period_wrapper-left">
                                Select Files
                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                            </div>
                            <div className="true-comply-upload__stepthree-body__period_wrapper-right true-comply-upload__stepthree-body__upload_wrapper-right">
                                <Form.Label
                                    className="true-comply-upload__stepthree-body__upload_wrapper-right-label"
                                    onClick={() => document.getElementById('uploadReport').click()}
                                    data-testid="handleFileUpload-input"
                                >
                                    Select a file
                                </Form.Label>
                                <input type="file" id="uploadReport" name="myfile" accept=".csv" onChange={handleFileUpload} data-testid="handleFileUpload-input-change" />
                            </div>
                        </>
                    ) : (
                        <div className="true-comply-upload__stepthree-body__upload_wrapper-selected-file">
                            {fileName}
                            <img src={closeReport} alt="close icon" onClick={onHandleReportClose} aria-hidden="true" data-testid="close-report" />
                        </div>
                    )
                }
            </div>
            <div style={{ paddingTop: '30px' }}>
                <Select
                    value={institution}
                    placeholder="Select Institution"
                    onSelect={onSelectInstitution}
                >
                    <SelectOption key={1} value="bhc">BHC</SelectOption>
                    <SelectOption key={2} value="shc">SHC</SelectOption>
                    <SelectOption key={3} value="ihc">IHC</SelectOption>
                    <SelectOption key={4} value="slhc">SLHC</SelectOption>
                </Select>
            </div>
            <div>
                {institution === 'slhc' && (
                    <div className="true-comply-upload__stepthree-body__period_wrapper">
                        <div className="true-comply-upload__stepthree-body__period_wrapper-left">
                            Does it fall under the covered SLHCs as defined by the final capital rule?
                            <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                        </div>
                        <div className="true-comply-upload__stepthree-body_question">
                            <RadioGroup onChange={ques1}>
                                <Radio value="Yes">Yes</Radio>
                                <Radio value="No">No</Radio>
                            </RadioGroup>
                        </div>
                    </div>
                )}
                <div className="true-comply-upload__stepthree-body__period_wrapper">
                    <div className="true-comply-upload__stepthree-body__period_wrapper-left">
                        Does your holding company fall under Non-Advanced Approaches Banking Organizations?
                        <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                    </div>
                    <div className="true-comply-upload__stepthree-body_question">
                        <RadioGroup onChange={ques3}>
                            <Radio value="Yes">Yes</Radio>
                            <Radio value="No">No</Radio>
                        </RadioGroup>
                    </div>
                </div>
                <div className="true-comply-upload__stepthree-body__period_wrapper">
                    <div className="true-comply-upload__stepthree-body__period_wrapper-left">
                        Is your holding company subject to category III capital standards?
                        <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                    </div>
                    <div className="true-comply-upload__stepthree-body_question">
                        <RadioGroup onChange={ques8}>
                            <Radio value="Yes">Yes</Radio>
                            <Radio value="No">No</Radio>
                        </RadioGroup>
                    </div>
                </div>
                <div className="true-comply-upload__stepthree-body__period_wrapper">
                    <div className="true-comply-upload__stepthree-body__period_wrapper-left">
                        Does your holding company have a community bank leverage ratio (CBLR) framework election in effect as of the
                        report date?
                        <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                    </div>
                    <div className="true-comply-upload__stepthree-body_question">
                        <RadioGroup onChange={ques9}>
                            <Radio value="Yes">Yes</Radio>
                            <Radio value="No">No</Radio>
                        </RadioGroup>
                    </div>
                </div>
            </div>
        </div>
    </>
);

export default FFIEC041UploadTabThree;
